(function() {
    'use strict';
    
    // Namespace all functions to avoid conflicts
    const DeliveryEstimate = {
        // Function to add business days to a date
        addBusinessDays: function(date, days) {
            let count = 0;
            while (count < days) {
                date.setDate(date.getDate() + 1);
                let dayOfWeek = date.getDay();
                if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                    count++;
                }
            }
            return date;
        },

        // Function to format a date as "25 Iunie"
        formatDate: function(date) {
            const months = [
                "Ian", "Feb", "Martie", "Apr", "Mai", "Iunie",
                "Iulie", "Aug", "Sept", "Oct", "Noi", "Dec"
            ];
            return `${date.getDate()} ${months[date.getMonth()]}`;
        },

        // Function to get the time remaining until cutoff
        getTimeUntilCutoff: function(cutoffHour) {
            const now = new Date();
            const cutoff = new Date();
            cutoff.setHours(cutoffHour, 0, 0, 0);
            if (now.getHours() >= cutoffHour) {
                cutoff.setDate(now.getDate() + 1);
            }
            const diff = cutoff - now;
            const hours = Math.floor(diff / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            return { hours, minutes };
        },

        // Function to get the delivery estimate message
        getDeliveryEstimateMessage: function(cutoffHour) {
            const now = new Date();
            let shippingDate = new Date();

            if (now.getHours() >= cutoffHour) {
                shippingDate = this.addBusinessDays(shippingDate, 1);
            }

            const deliveryStartDate = this.addBusinessDays(new Date(shippingDate), 1);
            const deliveryEndDate = this.addBusinessDays(new Date(shippingDate), 4);

            const timeUntilCutoff = this.getTimeUntilCutoff(cutoffHour);

            return `<p>✓ <span class="in-stock">În Stoc</span> Comandă în următoarele <span class="bold">${timeUntilCutoff.hours}h ${timeUntilCutoff.minutes}m</span> și vei primi comanda între <span class="bold">${this.formatDate(deliveryStartDate)} - ${this.formatDate(deliveryEndDate)}</span></p>`;
        },

        // Initialize the delivery estimate
        init: function(cutoffHour) {
            const deliveryEstimateMessage = this.getDeliveryEstimateMessage(cutoffHour);
            const elements = document.getElementsByClassName('delivery-estimate');
            
            for (let i = 0; i < elements.length; i++) {
                elements[i].innerHTML = deliveryEstimateMessage;
            }
        }
    };

    // Wait for DOM to be ready before executing
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            DeliveryEstimate.init(15);
        });
    } else {
        // DOM is already ready
        DeliveryEstimate.init(15);
    }
})();